<template>
  <div>
    <ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-8692126964022278"
     data-ad-slot="2027056281"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
  </div>
</template>

<script>
export default {
  name: 'HomeAdSense',
  mounted() {
    // Google AdSenseのスクリプトがすでに読み込まれているか確認
    console.log("HomeAdSense already")
    if (window.adsbygoogle && window.adsbygoogle.loaded) {
      // スクリプトがロードされている場合、広告を表示
      window.adsbygoogle.push({});
    } else {
      // スクリプトがロードされていない場合、スクリプトを動的に追加
      const adScript = document.createElement('script');
      adScript.async = true;
      adScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8692126964022278';
      adScript.crossOrigin = 'anonymous';
      adScript.onload = () => {
        window.adsbygoogle.push({});
      };
      document.head.appendChild(adScript);
    }
  }
}
</script>

<style scoped>
/* 必要に応じてスタイルを調整 */
</style>
